export const GET_GOOD_ORDER_LIST = 'GET_GOOD_ORDER_LIST';
export const SET_GOOD_ORDER_LOADING = 'SET_GOOD_ORDER_LOADING';
export const SET_GOOD_ORDER_LIST = 'SET_GOOD_ORDER_LIST';
export const GET_APPS_ORDER_LIST = 'GET_APPS_ORDER_LIST';
export const SET_APPS_ORDER_LIST = 'SET_APPS_ORDER_LIST';
export const SET_APPS_ORDER_LOADING = 'SET_APPS_ORDER_LOADING';
export const EMPTY_ORDER_LIST = 'EMPTY_ORDER_LIST';
export const GET_GAME_LIST = 'GET_GAME_LIST';
export const SET_GAME_LIST = 'SET_GAME_LIST';
export const SET_GAME_LIST_LOADING = 'SET_GAME_LIST_LOADING';
